import React from "react";
import "./DeclineModal.css";

const DeclineModal = ({ isOpen, onClose, onProceed }) => {
  if (!isOpen) return null;

  return (
    <div className="decline-modal-overlay">
      <div className="decline-modal-content">
        <button onClick={onClose} className="decline-modal-close-button">
          <span>&times;</span>
        </button>
        <div className="decline-modal-body">
          <img
            src={"/images/declineImage.png"}
            alt="Event"
            className="decline-event-image"
          />
          <h2 className="decline-event-title">Awwww!!!</h2>
          <p className="decline-event-description">
            Thanks for letting us know you won't be able to make it. We're
            disappointed you can't join us.
            <p>Press proceed to decline.</p>
          </p>
          <div className="decline-modal-buttons">
            <button onClick={onClose} className="decline-modal-cancel-button">
              Close
            </button>
            <button
              onClick={onProceed}
              className="decline-modal-proceed-button"
            >
              Proceed
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeclineModal;
